export enum Title {
  Madam = 'Madame',
  Mister = 'Monsieur',
  Unknown = 'Inconnu',
}
